import React from 'react';
import PropTypes from 'prop-types';
import he from 'he';
import '@/scss/main.scss';
import '@/lib/font-awesome/css/fontawesome-all.min.css';
import { registerLicense } from '@syncfusion/ej2-base';
registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5WdE1iWHtccXRdRWdcWkdx'); // 29.X.X

class App extends React.Component {
	constructor(props, context) {
		super(props, context);

		let preLoadedState = he.decode(window.__PRELOADED_STATE__);
		preLoadedState = JSON.parse(preLoadedState);
		this.state = {...preLoadedState};
	}

	render() {
		let viewProps = {
			appState: this.state
		};

		return (
			<div className='App'>
				{/*
				NOTE this is needed for the current 'bootstrap the view' approach
				that allows a shared app bundle/component among different view bundles.
				if we were to do 'import SomeView...', the view source would get bundled
				into tropic.bundle or commons.bundle. Instead, we import tropic/App.v2
				in the Views, and webpack sees a shared dependency and puts it in
				commons.bundle
				*/}
				{React.cloneElement(this.props.children, {...viewProps})}
			</div>
		);
	}
}

App.propTypes = {
	children: PropTypes.object.isRequired
};

export default App;
